import { css } from 'styled-components';

export const heading01global01 = css`
  font-size: 20px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global01};
`;

export const heading01global02 = css`
  font-size: 20px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global02};
`;

export const heading01global03 = css`
  font-size: 20px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global03};
`;

export const heading01global04 = css`
  font-size: 20px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global04};
`;

export const heading02global01 = css`
  font-size: 16px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global01};
`;

export const heading03global01 = css`
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global01};
`;

export const heading03global02 = css`
  font-size: 14px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.primary.bold};
  color: ${({ theme }) => theme.palette.global02};
`;

export const paragraph01global02 = css`
  font-size: 12px;
  font-weight: 600;
  font-family: ${({ theme }) => theme.fonts.secondary.light};
  color: ${({ theme }) => theme.palette.global02};
`;

export default {
  heading01global01,
  heading01global02,
  heading01global03,
  heading01global04,
  heading02global01,
  heading03global01,
  heading03global02,
  paragraph01global02,
};



// WEBPACK FOOTER //
// /opt/build/repo/src/app/config/textStyles.js